import { NgModule, ModuleWithProviders, APP_INITIALIZER } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { InitializerService } from './initializer.service';
import { ServerClientContextLoader } from './interfaces/server-client-context-loader';

export function init_app(initializer: InitializerService, serverLoader: ServerClientContextLoader) {
  const initAppFunction = () => { return initializer.init(serverLoader.load); };
  return initAppFunction;
}


@NgModule({
  imports: [
    HttpClientModule
  ],
  declarations: [],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: init_app,
      deps: [InitializerService, ServerClientContextLoader],
      multi: true
    }
  ]
})
export class InitializerModule {
  static forRoot(configUrl: string, clientContextUrl: string, serverLoader: any): ModuleWithProviders<InitializerModule> {
    return {
      ngModule: InitializerModule,
      providers: [
        {
          provide: 'CONFIG_URL',
          useValue: configUrl
        },
        {
          provide: 'CLIENT_CONTEXT_URL',
          useValue: clientContextUrl
        },
        { provide: ServerClientContextLoader, useClass: serverLoader }
      ]
    }
  }
}
